export default __webpack_public_path__ + "static/media/car-notconnected.5a7cd4bd.png";